<template>
  <div class="session-authorization pa-10">
    <title-page icon="ico-carplug">
      {{ $t('session-authorization.logs') }}
    </title-page>
    <session-authorization-list :chargingPoint="chargingPoint"/>

  </div>
</template>

<script>


import SessionAuthorizationList from "@/components/elements/SessionAuthorizationList.vue";


export default {
  components: {
    SessionAuthorizationList
  },

  computed: {
    chargingPoint() {
      return this.$parent.chargingPoint ?? null
    }
  },
}
</script>

<style lang="scss">


</style>
